import React from "react";

const TermsAndConditions = () => (
  <div className="max-w-3xl mx-auto p-6 text-justify">
    <h1 className="text-3xl font-bold mb-4">Términos y Condiciones de Uso</h1>
    <p className="mb-4">Fecha de entrada en vigor: 23 de junio de 2025</p>
    <h2 className="text-xl font-semibold mt-6 mb-2">1. Aceptación de los Términos</h2>
    <p className="mb-4">
      Al acceder y utilizar nuestra plataforma web y la aplicación móvil (en adelante, "la App"), usted acepta cumplir con estos Términos y Condiciones. Si no está de acuerdo, por favor no utilice nuestros servicios.
    </p>
    <h2 className="text-xl font-semibold mt-6 mb-2">2. Descripción del Servicio</h2>
    <p className="mb-4">
      Ofrecemos una plataforma web y una aplicación Android para la gestión de operaciones logísticas, incluyendo la recolección de datos de ubicación GPS del operador para optimizar procesos y garantizar la seguridad de las operaciones.
    </p>
    <h2 className="text-xl font-semibold mt-6 mb-2">3. Recolección y Uso de Datos</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>Recolectamos información personal como nombre, correo electrónico, y datos de contacto para la gestión de usuarios.</li>
      <li>La app Android solicita acceso a la ubicación GPS del dispositivo para registrar y monitorear la ubicación del operador durante el uso de la aplicación.</li>
      <li>La información de ubicación se utiliza exclusivamente para fines operativos y de seguridad, y no se comparte con terceros no autorizados.</li>
      <li>Todos los datos se almacenan y procesan conforme a la legislación vigente en materia de protección de datos.</li>
    </ul>
    <h2 className="text-xl font-semibold mt-6 mb-2">4. Permisos de la Aplicación Android</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>La app solicita permiso para acceder a la ubicación en segundo plano, conforme a los requisitos de Google Play, únicamente cuando es necesario para la funcionalidad principal.</li>
      <li>El usuario puede revocar estos permisos en cualquier momento desde la configuración del dispositivo.</li>
    </ul>
    <h2 className="text-xl font-semibold mt-6 mb-2">5. Consentimiento del Usuario</h2>
    <p className="mb-4">
      Al utilizar la app, el usuario otorga su consentimiento explícito para la recolección y uso de sus datos personales y de ubicación, según lo descrito en este documento.
    </p>
    <h2 className="text-xl font-semibold mt-6 mb-2">6. Derechos del Usuario</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>El usuario puede solicitar el acceso, rectificación o eliminación de sus datos personales en cualquier momento.</li>
      <li>Para ejercer estos derechos, puede contactarnos a través del correo electrónico proporcionado al final de este documento.</li>
    </ul>
    <h2 className="text-xl font-semibold mt-6 mb-2">7. Responsabilidades del Usuario</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>El usuario se compromete a proporcionar información veraz y a hacer un uso adecuado de la plataforma y la app.</li>
      <li>Está prohibido el uso de la app para fines ilícitos o no autorizados.</li>
    </ul>
    <h2 className="text-xl font-semibold mt-6 mb-2">8. Modificaciones</h2>
    <p className="mb-4">
      Nos reservamos el derecho de modificar estos Términos y Condiciones en cualquier momento. Las modificaciones serán notificadas a través de la plataforma o la app.
    </p>
    <h2 className="text-xl font-semibold mt-6 mb-2">9. Cumplimiento con Google Play</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>La app cumple con las políticas de Google Play respecto a la privacidad, uso de datos y permisos de ubicación.</li>
      <li>Se proporciona información clara sobre el uso de la ubicación y el usuario puede gestionar los permisos en todo momento.</li>
    </ul>
    <h2 className="text-xl font-semibold mt-6 mb-2">10. Contacto</h2>
    <p className="mb-4">
      Para cualquier duda, solicitud o ejercicio de derechos relacionados con sus datos personales, puede contactarnos en: <a href="mailto:m_herrera@amerisa.com.mx" className="text-blue-600 underline">m_herrera@amerisa.com.mx</a>
    </p>
    <p className="text-sm text-gray-500 mt-8">Última actualización: 23 de junio de 2025</p>
  </div>
);

export default TermsAndConditions;
